import { Subscription } from "rxjs";
import { observable, action, runInAction } from "mobx";

import { MainOfferStore } from "@gp/offer";
import type { RootStore } from "@state/stores/types";
import { BetStatus } from "@utils";
import { rawFilter } from "@api-types/my-bets/Filter";

export class ActiveEventsStore extends MainOfferStore {
	rootStore: RootStore;

	constructor(rootStore: RootStore) {
		super();
		this.rootStore = rootStore;
	}

	@observable liveFeedSubscription: Subscription | null = null;

	@action.bound
	fetchActiveEvents(
		eventIds: string[],
		selectedBettingType?: rawFilter["betStatusAbrv"]
	) {
		this.onDispose();

		if (selectedBettingType == BetStatus.CLOSED || eventIds.length === 0) {
			return;
		}

		try {
			this.liveFeedSubscription = this.rootStore.hub
				.getOfferSubscription({
					subscriptionId: `active-events-/${eventIds.join("/")}`,
					channels: [
						{
							name: "event",
							filter: {
								id: {
									eq: eventIds,
								},
							},
						},
					],
					compress: WEBPACK_OFFER_COMPRESS,
				})
				.subscribe({
					next: (response) => {
						runInAction(() => {
							this.assignOfferData(response);
						});
					},
					error: (err) => {
						console.error("console.error", err);
					},
				});
		} catch (error) {
			console.error(error);
		}
	}

	@action.bound
	onDispose() {
		if (this.liveFeedSubscription) {
			this.liveFeedSubscription.unsubscribe();
			this.liveFeedSubscription = null;
		}
	}
}
